import { CommandMenuQueryNode } from '#pplx/frontend/composer-sdk/lexical/nodes/CommandMenuQueryNode.js';
import { MentionNode } from '#pplx/frontend/composer-sdk/lexical/nodes/MentionNode.js';
import { SlashHintNode } from '#pplx/frontend/composer-sdk/lexical/nodes/SlashHintNode.js';
import { AutoLinkNode, LinkNode } from '@lexical/link';
/**
 * Nodes every composer surface needs unconditionally. MentionNode remains core
 * because Composer can restore and insert mentions without typeahead; other
 * custom nodes are contributed via `CAPABILITY_NODES` when a plugin declares
 * the matching capability.
 */
export const CORE_NODES = [MentionNode];
/**
 * Full node registry. Non-Composer callers that still build their own
 * `initialConfig` (e.g. `ResizableInput`, standalone serializer utilities)
 * read from here. `<Composer />` derives its nodes from declared plugin
 * capabilities instead — see `resolveNodesForPlugins`.
 */
export const NODES = [MentionNode, SlashHintNode, CommandMenuQueryNode, AutoLinkNode, LinkNode];
//# sourceMappingURL=Nodes.js.map